//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { IssueNotificationType } from '../Shared/Maint/MaintModels';
import { SubmissionList } from './SubmissionList';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
}

export class SubmissionList_Comment {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected SubmissionList: SubmissionList) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openSubmissionIssueCommentForm = (activityUID: string): void => {
        const self = this;

        var showclass = "show600";
        var autoShowList = false;
        if (Utilities.IsListFormPinned(self.SubmissionList.pinListFormEl) == false) {
            showclass = "show";
            autoShowList = true;
            $('#submissionListPanel').removeClass('show');
            $('#submissionListEditContainer').removeClass('show600');
        }

        $('#submissionListEditContainer').addClass(showclass);
        Utilities.BlockUI($('#submissionListEditContainer'));
        $('#submissionListEditContainer').load(window.G_SITEFOLDERNAME +'/Submissions/IssueCommentView', { activityUID: activityUID }, function (response, status, xhr) {
            Utilities.UnBlockUI($('#submissionListEditContainer'));

            $('#submissionIssueCommentCloseBtn').on('click', function () {
                $('#submissionListEditContainer').removeClass(showclass);
                if (autoShowList == true) $('#submissionListPanel').addClass('show');
                self.SubmissionList.treeView.treeview('unselectAll', { silent: true });
            });

            // Bind buttons
            $('#submissionIssueCommentEditForm [data-submission-contactbtn]').on("click", function () {
                let data: ICAMSKey = { code: $('#submissionIssueCommentEditForm [name="LogBy"]').val().toString(), featureType: FeatureType.Contact };
                events.bus.publish(events.eventOpenContactsEditPanel([data, true, null]));
            });
            $('#submissionIssueCommentEditForm [data-submission-zoommaintbtn]').on("click", function () {
                let WKT = $('#submissionIssueCommentEditForm [name="MaintWKT"]').data("maintwkt");
                if (WKT == null) {
                    toastr.info("No geometry associated with this record.");
                }
                else {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[WKT], true, true, FeatureType.Maint]));
                }
                this.blur();
            });
            $('#submissionIssueCommentEditForm [data-submission-zoomparentbtn]').on("click", function () {
                let WKT = $('#submissionIssueCommentEditForm [name="ParentWKT"]').data("parentwkt");
                if (WKT == null) {
                    toastr.info("No geometry associated with this record.");
                }
                else {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[WKT], true, true, FeatureType.Maint]));
                }
                this.blur();
            });
            $('[name="submissionIssueCommentContactListBtn2"]').on("click", function () {
                let contactRef = $(this).data('contactref');
                events.bus.publish(events.eventOpenAssignedTasksForm(contactRef));
                this.blur();
            });
            $('[name="submissionIssueCommentReportedProblemBtn"]').on("click", function () {
                let num = $(this).data("num");
                let btn = $('[name="ReportedComment_' + num + '"]');
               
                if (btn.prop("disabled") == true) {
                    btn.prop("disabled", false);
                    $(this).css('color', 'green');
                }
                else {
                    btn.prop("disabled", true);
                    $(this).css('color', 'black');
                }
                this.blur();
            });
            $('[name="submissionIssueCommentCopyReportedBtn"]').on("click", function () {
                let num = $(this).data("num");
                let text = $('[name="ReportedComment_' + num + '"]').val();
                $('[name="Comment_' + num + '"]').val(text);
            });

            // Get form validation
            Utilities.InitFormValidation($("submissionIssueEditForm"));

            $('[name="submissionSubmitBtn"]').on('click', function (evt) {

                evt.preventDefault();

                // Validate
                let num = $(this).data("num");
                let maintCode = $('[name="MaintCode"]').val() as string;
                let reportedComment = $('[name="ReportedComment_' + num + '"]').val();
                var UID = $('[name="UID_' + num + '"]').val();
                //let text = $('[name="Comment_' + num + '"]').val();
                //if (text == null || text == '') {
                //    toastr.error("Please fill in a comment!");
                //    return;
                //}

                Utilities.BlockUI($('#submissionListEditContainer'));
                let data = { maintCode: maintCode, UID: UID, reportedComment: reportedComment };
                $.ajax({
                    type: "POST",
                    dataType: "text",
                    url: '/Submissions/AcceptComment',
                    data: data,
                    success: function (response) {
                        try {
                            let result = JSON.parse(response);
                            if (result.success == true) {
                                toastr.info('Updated issue comment!');
                                self.GetTreeData();
                                self.SubmissionList.GetSubmissionCounts();
                                $('#submissionListEditContainer').removeClass(showclass);
                                if (autoShowList) $('#submissionListPanel').addClass('show');

                                self.SubmissionList.openSubmissionIssueResponseForm(maintCode, IssueNotificationType.Accepted);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message);
                                else toastr.error('Failed to update issue comment!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($('#submissionListEditContainer'));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            //JR #640 - DELETE BTN - calling new controller endpoint
            $('[name="submissionDeleteBtn"]').on('click', function (evt) {

                evt.preventDefault();
                Utilities.BlockUI($('#submissionListEditContainer'));

                let num = $(this).data("num");
                let maintCode = $('[name="MaintCode"]').val();
                var UID = $('[name="UID_' + num + '"]').val();
                let data = { maintCode: maintCode, UID: UID };

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
                    if (r.yes == true) {
                        doDelete();
                    }
                    else {
                        Utilities.UnBlockUI($('#submissionListEditContainer'));
                    }
                }).catch(e => { });

                function doDelete() {
                    $.ajax({
                        type: "POST",
                        dataType: "text",
                        url: '/Submissions/DeleteComment',
                        data: data,
                        success: function (response) {
                            try {
                                let result = JSON.parse(response);
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                    self.GetTreeData();
                                    self.SubmissionList.GetSubmissionCounts();
                                    $('#submissionListEditContainer').removeClass(showclass);
                                    if (autoShowList) $('#submissionListPanel').addClass('show');
                                }
                                else {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.UnBlockUI($('#submissionListEditContainer'));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }

            });

            //JR #640 - SAVE ONLY BTN - calling new controller endpoint
            $('[name="submissionSaveBtn"]').on('click', function (evt) {

                evt.preventDefault();
                
                // Validate
                let num = $(this).data("num");

                if ($('[name="ReportedComment_' + num + '"]').val().toString() == "") {
                    toastr.error("The Reported Problem cannot be blank.");
                    return;
                }

                let maintCode = $('[name="MaintCode"]').val();
                let reportedComment = $('[name="ReportedComment_' + num + '"]').val();
                var UID = $('[name="UID_' + num + '"]').val();
                let text = $('[name="Comment_' + num + '"]').val();
                /*if (text == null || text == '') {
                    toastr.error("Please fill in a comment!");
                    return;
                }*/

                Utilities.BlockUI($('#submissionListEditContainer'));
                let data = { maintCode: maintCode, UID: UID, comment: text, reportedComment: reportedComment };
                $.ajax({
                    type: "POST",
                    dataType: "text",
                    url: '/Submissions/SaveComment',
                    data: data,
                    success: function (response) {
                        try {
                            let result = JSON.parse(response);
                            if (result.success == true) {
                                toastr.info('Saved issue comment!');
                                self.GetTreeData();
                                self.SubmissionList.GetSubmissionCounts();
                                $('#submissionListEditContainer').removeClass(showclass);
                                if (autoShowList) $('#submissionListPanel').addClass('show');
                            }
                            else {
                                toastr.error('Failed to save issue comment!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($('#submissionListEditContainer'));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            //JR #640 - CANCEL BTN
            $('[name="submissionCancelBtn"]').on('click', function (evt) {

                $('#submissionListEditContainer').removeClass(showclass);
                if (autoShowList) $('#submissionListPanel').addClass('show');
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    public GetTreeData = (): void => {
        const self = this;

        // Get the selected view
        let viewName = "";
        let filterDef: IFilterDefinitionModel = $('#submissionRecordFilter').children("option:selected").data('filterdefinition');
        if (filterDef != null) { viewName = filterDef.viewName; }

        let url = "/Submissions/GetSubmissionCommentTreeData";
        let query = {
            data: { viewName: viewName, Order: self.SubmissionList.currentSortOrder, OrderDirection: self.SubmissionList.currentSortDirection, Skip: self.SubmissionList.currentPage * self.SubmissionList.issueMaxNumberInList, Take: self.SubmissionList.issueMaxNumberInList }
        };

        Utilities.BlockUI($('#submissionListResultsContainer'));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.SubmissionList.DeleteAllNodes();

                        // Create tree
                        var data = result.data.nodes as Array<INode>;
                        self.SubmissionList.createTreeData(data);
                        self.SubmissionList.createTree(self.SubmissionList.treeData, true);
                        self.createTreeHeader();

                        // Update UI
                        self.SubmissionList.updatePagingUI();
                        self.SubmissionList.checkVisibleButtons();

                        // Update count
                        var countStr = "";
                        if (result && result.data && result.data.totalCount) {
                            countStr = " (" + result.data.totalCount + ")";
                            self.SubmissionList.issueCountFromServer = result.data.totalCount;
                        }

                        self.SubmissionList.actionBtns.viewprint.enable = false;
                        self.SubmissionList.actionBtns.showmap.enable = true;
                        self.SubmissionList.actionBtns.delete.enable = false;
                        self.SubmissionList.actionBtns.query.enable = false;
                        self.SubmissionList.actionBtns.reject.enable = false;

                        //$("#submissionSelectedView_TitleCount").html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#submissionListResultsContainer'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;

        // Add the header to issues only
        var colDef = [
            { label: "ID", value: null, size: 1 },
            { label: "Logged", value: null, size: 2 },
            { label: "Report by", value: null, size: 3 },
            { label: "Type", value: null, size: 4 },
            { label: "Parish", value: null, size: 2 }
        ];

        // Create the header
        self.SubmissionList.treeView.treeview('addHeader', {
            cols: colDef,
            currentSortDirection: self.SubmissionList.currentSortDirection,
            currentSortOrder: self.SubmissionList.currentSortOrder,
            callback: function (order, dir) {
                self.SubmissionList.currentSortOrder = order;
                self.SubmissionList.currentSortDirection = dir;
                self.GetTreeData();
            }
        });

    }

}




